import React, { useState } from 'react';

const galleryImages = [
  { id: 1, src: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600', category: 'Campus', title: 'Main Building' },
  { id: 2, src: 'https://images.unsplash.com/photo-1551076805-e1869033e561?w=600', category: 'Training', title: 'Simulation Lab' },
  { id: 3, src: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600', category: 'Facilities', title: 'Modern Library' },
  { id: 4, src: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600', category: 'Clinical', title: 'Hospital Training' },
  { id: 5, src: 'https://images.unsplash.com/photo-1584515933487-779824d29309?w=600', category: 'Events', title: 'Annual Day' },
  { id: 6, src: 'https://images.unsplash.com/photo-1581056771107-24ca5f033842?w=600', category: 'Campus', title: 'Student Hostel' },
  { id: 7, src: 'https://images.unsplash.com/photo-1551190822-a9333d879b1f?w=600', category: 'Training', title: 'Practical Session' },
  { id: 8, src: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600', category: 'Research', title: 'Science Lab' },
];

function Gallery() {
  const [filter, setFilter] = useState('All');
  const categories = ['All', ...new Set(galleryImages.map(img => img.category))];
  const filtered = filter === 'All' ? galleryImages : galleryImages.filter(img => img.category === filter);

  return (
    <section id="gallery" className="gallery-section">
      <div className="section-container">
        <h2 className="section-title"><span className="title-icon">🖼️</span> Photo Gallery</h2>
        <div className="gallery-filters">
          {categories.map(cat => (
            <button key={cat} className={`filter-btn ${filter === cat ? 'active' : ''}`} onClick={() => setFilter(cat)}>
              {cat}
            </button>
          ))}
        </div>
        <div className="gallery-grid">
          {filtered.map(img => (
            <div key={img.id} className="gallery-item">
              <img src={img.src} alt={img.title} />
              <div className="gallery-overlay">
                <h4>{img.title}</h4>
                <span>{img.category}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Gallery;